export const roundUpToQuarterHourHoursFromMinutes = (totalMinutes) => {
    if (totalMinutes <= 0) return 0;
    const roundedMinutes = Math.ceil(totalMinutes / 15) * 15;
    return roundedMinutes / 60;
};

export const diffMinutes = (horaIngreso, horaEgreso) => {
    const ingreso = new Date(horaIngreso);
    const egreso = new Date(horaEgreso);
    return Math.floor((egreso.getTime() - ingreso.getTime()) / 60000);
};

export const calculaPrecioNormalCuidador = (horaIngreso, horaEgreso, precioPorHora, frecuencia) => {
    const minutosTotales = diffMinutes(horaIngreso, horaEgreso);
    const minutosNormales = minutosTotales > frecuencia * 60 ? frecuencia * 60 : minutosTotales;
    const horasNormales = roundUpToQuarterHourHoursFromMinutes(minutosNormales);
    return precioPorHora * horasNormales;
};

export const calculaPrecioExtraDuracion = (horaIngreso, horaEgreso, precioPorHora, esCuidador, frecuencia) => {
    if (!horaIngreso || !horaEgreso || !esCuidador) return 0;

    const minutosTotales = diffMinutes(horaIngreso, horaEgreso);
    const minutosNormales = frecuencia * 60;

    if (minutosTotales <= minutosNormales) return 0;

    const minutosExtra = minutosTotales - minutosNormales;
    const horasExtra = roundUpToQuarterHourHoursFromMinutes(minutosExtra);

    const precioTotal = precioPorHora * horasExtra;
    return (isNaN(precioTotal) || !precioTotal) ? 0 : precioTotal;
};